import React, { useContext,  useEffect,  useRef,  useState } from 'react'
import styles from './post.module.css'
import {HiOutlineDotsVertical,HiOutlineDocumentDownload,HiDocumentDownload} from 'react-icons/hi'
import {AiOutlinePlayCircle,AiOutlinePauseCircle,AiOutlineSend} from 'react-icons/ai'
import {RiShareForwardLine} from 'react-icons/ri'
import {IoIosShareAlt} from 'react-icons/io'
import {FaRegComment,FaRegHeart} from 'react-icons/fa'
import { Carousel } from 'react-responsive-carousel';
import {FiDownload} from 'react-icons/fi'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { UserDataContext } from '../../context/userData'
import useVisibilitySensor from "@rooks/use-visibility-sensor"

const Post = (props)=>{
    const {userData}=useContext(UserDataContext)
    const videoRef = useRef(null);
    const [playing, setPlaying] = useState(false);

    const [moreOptionToggle,setmoreOptionToggle] =useState(false);
  
    const { isVisible, visibilityRect } = useVisibilitySensor(videoRef, {
        intervalCheck: 10,
        scrollCheck: true,
        resizeCheck: true
    });
  


  const handleVideoPress = () => {
    if (playing) {
      videoRef.current.pause();
      setPlaying(false);
    } else {
      videoRef.current.play();
      setPlaying(true);
    }
  };
    
    return(
        <div  className={styles.Container}>
            <div className={styles.topBar}>
                <div className={styles.user}>
                <img className={styles.userimg} alt="profile"  src={`${userData.Profile_Image}`}/>
                <div className={styles.username}>arham_choudhary
                <div>Delhi</div>
                 </div>
                 </div>
                 <div className={styles.dots}>
                 <HiOutlineDotsVertical style={{cursor:"pointer"}} onClick={()=>setmoreOptionToggle(!moreOptionToggle)}/>
                </div>
                </div>
                {moreOptionToggle?
                <div className={styles.moreOption}>
                    <div>
                        Report
                    </div>
                    <div>
                        Block user
                    </div>
                    <div>
                        Mute account
                    </div>

                </div>:""}

                    {props.Type==="image"?
                <img className={styles.img} src={props.Post_Url} />:""}

                {props.Type==="video"?
                <div>
            <video 
            
            ref={videoRef}
            onClick={handleVideoPress}
            className={styles.video} width="100%" height="100%" >
           <source  src="http://vsam.me/api/videos/hello.mp4" type="video/mp4"  />
            
          </video>
          {playing?<AiOutlinePlayCircle className={styles.playicon} />:<AiOutlinePauseCircle className={styles.playicon} />}
            </div>
            :""
            }
                
                <div className={styles.action}>
                    <div className={styles.lcs}>
                    <FaRegHeart/>
                    <FaRegComment/>
                    <RiShareForwardLine/>
                    
                   </div>
                  <div className={styles.saveIcon}>
                    {true?<HiOutlineDocumentDownload/>:
                     <HiDocumentDownload/>}
                  </div>
                     </div>
                   
                     <div className={styles.info}>
                       <div>
                           shaun, tp0078 & 115 others liked it.
                       </div>
                       <div className={styles.capCon} >
                       <div style={{fontWeight:"700"}} >arham_choudhary</div>
                  <div className={styles.capstion} >{props.Caption}</div>
                                   
              

                </div>
                       {/* <div>
                           11 Commnets
                       </div> */}
                        <div>2 hours ago</div>
                        <br/>
                           <div className={styles.commetPost}>
             <img src="https://vsam.me/api/images/010421024708219727ab384186e84317b25550adfdcb25231.png" />
             <input placeholder="Post a Comment ..." />
             <AiOutlineSend/>       


        </div>

                   </div>
        




        </div>
    )
}

export default Post